/******************************************************************
 * Archivo : client/src/mutations/editUserDetails.js
 * Proyecto: CB30
 * Módulo  : Usuarios
 * Proceso : Actualización de datos personales
 ******************************************************************/

import gql from 'graphql-tag';

export default gql`
  mutation EditUserDetails(
    $action: String
    $userId: ID!
    $documento_de_identidad: String!
    $tipo_de_documento: String!
    $lugar_de_expedicion: String!
    $fecha_de_nacimiento: String!
    $lugar_de_nacimiento: String!
    $pais_de_nacimiento: String!
    $genero: String!
    $raza: String!
    $grupo_etnico: String!
    $estado_civil: String!
    $nivel_educativo: String!
    $ocupacion: String!
    $direccion: String!
    $estrato: Int!
    $localidad: String!
    $departamento: String!
    $ciudad: String!
    $pais_de_residencia: String!
    $telefono: String!
    $celular: String!
  ) {
    editUserDetails(
      action: $action
      userId: $userId
      documento_de_identidad: $documento_de_identidad
      tipo_de_documento: $tipo_de_documento
      lugar_de_expedicion: $lugar_de_expedicion
      fecha_de_nacimiento: $fecha_de_nacimiento
      lugar_de_nacimiento: $lugar_de_nacimiento
      pais_de_nacimiento: $pais_de_nacimiento
      genero: $genero
      raza: $raza
      grupo_etnico: $grupo_etnico
      estado_civil: $estado_civil
      nivel_educativo: $nivel_educativo
      ocupacion: $ocupacion
      direccion: $direccion
      estrato: $estrato
      localidad: $localidad
      departamento: $departamento
      ciudad: $ciudad
      pais_de_residencia: $pais_de_residencia
      telefono: $telefono
      celular: $celular
    ) {
      documento_de_identidad
    }
  }
`;


// WEBPACK FOOTER //
// ./src/mutations/editUserDetails.js